import resolveConfig from 'tailwindcss/resolveConfig'

import tailwindConfig from '../../tailwind.config.mjs'

const config = resolveConfig(tailwindConfig)
const {
  theme: { colors },
} = config

export default colors
